import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Box,
  Button,
  ButtonGroup,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  Grid,
  Link,
  Paper,
  Skeleton,
  Slider,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  styled,
} from "@mui/material";
import clsx from "clsx";
import "sweetalert2/dist/sweetalert2.min.css";
import HomeScreenImg from "@/assets/earth.jpg";
import Logo from "@/assets/tableLogo.svg";
import { theme } from "@/components/Elements/theme";
import Notes from "./Notes";
import CurrencyFormat from "react-currency-format";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";
import StaticFAQ from "@/features/Faq/components/staticFAQ";
import trophy from "@/assets/trophy.png";
import { useAuth } from "@/lib/auth";
import { getLotteryCountById, useLotteryById } from "../api/getLotteryById";
import {
  lotteryDataValue,
  lotteryDataDTO,
  lotteryDataFnData,
} from "../api/postLottery";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import Swal from "sweetalert2";
import Countdown from "react-countdown";
import yellowt from "@/assets/yellow-t.png";
import whitet from "@/assets/white-t.png";
import "../../../components/Elements/CSS/style.css";
import { useLotteryCountById } from "../api/getLotteryCount";
import { axios } from "@/lib/axios";
import storage from "@/utils/storage";
import {
  yellow,
  blue,
  red,
  orange,
  green,
  brown,
  pink,
  purple,
} from "@mui/material/colors";
import { Padding } from "@mui/icons-material";
import moment from "moment";
import { getOrdinalSuffix } from "@/utils/utils";
import { LoadingModal } from "../modal/loadingModal";

interface SpinningBallData {
  _id: string;
  endDate: string;
  endTime: string;
  lotteryDrawDate: string;
  randomGeneratedBall: number;
  availableBalls: number[];
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    padding: theme.spacing(1),
  },
  paperClass: {
    padding: "40px",
    textAlign: "center",
    background: "rgba(5, 5, 24, 0.8)",
    borderRadius: "10px",
    boxSizing: "border-box",
    height: "100%",
    [theme.breakpoints.down("sm")]: {
      padding: "25px",
    },
  },
  first: {
    padding: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.text.secondary,
    height: "100%",
    paddingBottom: "20px !important",
    [theme.breakpoints.down("sm")]: {
      minHeight: "295px",
      paddingBottom: "10px !important",
    },
  },
  second: {
    padding: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.text.secondary,
    height: 150,
  },
  parentPaper: {
    padding: theme.spacing(2),
    margin: "auto",
    maxWidth: 1600,
  },
  availableTickets: {
    border: "0.5px solid rgba(255, 255, 255, 0.2)",
    borderRadius: "10px",
    height: 76,
    [theme.breakpoints.down("md")]: {
      height: "52px",
    },
  },
  noOfTickets: {
    background: "rgba(5, 5, 24, 0.8)",
    borderRadius: "10px",
    marginBlock: "25px",
    [theme.breakpoints.down("md")]: {
      marginBlock: "20px",
    },
  },
  tableContainer: {
    background: "#050518",
    borderRadius: 8,
    overflow: "hidden",
  },
  table: {
    minWidth: 650,
  },
  tableHeader: {
    color: "#fff",
    padding: "22px !important",
    [theme.breakpoints.down("lg")]: {
      padding: "10px 15px !important",
    },
    [theme.breakpoints.down("md")]: {
      padding: "10px !important",
    },
    [theme.breakpoints.down("sm")]: {
      padding: "5px 10px !important",
    },
  },
  logoTable: {
    [theme.breakpoints.down("lg")]: {
      height: "45px",
      width: "45px",
    },
    [theme.breakpoints.down("sm")]: {
      height: "35px",
      width: "35px",
    },
  },
  tableData: {
    fontSize: "14px",
    color: "#fff",
    opacity: "0.6",
    BorderBottom: "1px solid #0D0D39",
  },
  minimumTicket: {
    background: "#3C37FF",
    borderRadius: "10px",
    color: "#fffff",
  },
  logo: {
    width: 50,
  },
  myGridItem: {
    backgroundColor: "rgb(75 75 75 / 80%)",
    [theme.breakpoints.down("md")]: {
      padding: "15px 10px",
    },
    [theme.breakpoints.up("md")]: {
      padding: "30px",
    },
    borderRadius: "20px",
  },
  innerGrid: {
    backgroundColor: "#050518",
    padding: "10px 15px",
    borderRadius: "20px",
    height: "100%",
    boxSizing: "border-box",
  },
  innerGridFirst: {
    borderRadius: "20px",
    backgroundRepeat: "no-repeat",
    height: "100%",
    width: "100%",
    maxWidth: "100%",
    objectFit: "fill",
    backgroundPosition: "center center",
    [theme.breakpoints.down("md")]: {
      borderRadius: "10px",
    },
  },
  substract: {
    border: "1px solid #ffff !important",
    borderRadius: "10px !important",
    color: "#ffff",
  },
  innerGridSecond: {
    backgroundColor: "#050518",
    padding: "10px",
    borderRadius: "20px",
    [theme.breakpoints.down("md")]: {
      padding: "10px 6px",
    },
    [theme.breakpoints.down("sm")]: {
      padding: "10px 0px",
    },
  },
  ticketPrize: {
    background: "rgba(5, 5, 24, 0.8)",
    borderRadius: "10px",
    padding: "30px",
    [theme.breakpoints.down("md")]: {
      padding: "5px 10px",
    },
  },

  ballContainer: {
    position: "absolute",
    top: 0,
    right: 0,
    padding: theme.spacing(1),
  },
  cardContent: {
    position: "relative",
    padding: theme.spacing(2),
  },
  ballRow: {
    display: "flex",

    margin: theme.spacing(-1),
  },
  ball: {
    width: 21, // Adjust width of the ball
    height: 21, // Adjust height of the ball
    fontSize: 11, // Adjust font size of the ball number
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "#fff",
    borderRadius: "50%",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.3)",
    margin: theme.spacing(-0.5),
    backgroundImage: (props: any) =>
      `linear-gradient(135deg, ${props.color} 30%, ${props.colorDark} 90%)`,
    transition: "transform 0.3s ease-in-out", // Transition for animation
    "&:hover": {
      transform: "scale(1.9)", // Scale up on hover
    },
  },
  selectedBall: {
    transform: "scale(2.0)",
    border: "2px solid white",
    "@media screen and (max-width:992px)": {
      transform: "scale(1.5)",
    },
  },
  ballText: {
    marginTop: theme.spacing(1),
    fontSize: 12,
  },

  checkboxLabel: {
    fontSize: "12px",
    color: "#ffffff",
    "& .MuiSvgIcon-root": {
      fontSize: "16px",
      fill: "#ffffff",
    },
    "& .MuiTypography-body1": {
      fontSize: "12px",
    },
  },
}));

const PrettoSlider = styled(Slider)({
  color: "#3C37FF",
  height: 2,
  "& .MuiSlider-track": {
    border: "none",
  },
  "& .MuiSlider-thumb": {
    height: 10,
    width: 10,
    backgroundColor: "#fff",
    border: "10px solid rgba(255, 255, 255, 0.5)",
    "&:focus, &:hover, &.Mui-active, &.Mui-focusVisible": {
      boxShadow: "0px 10px 15px -3px rgba(0,0,0,0.1)",
    },
    "&:before": {
      display: "none",
    },
  },
  "& .MuiSlider-valueLabel": {
    lineHeight: 1.2,
    fontSize: 12,
    background: "unset",
    padding: 0,
    width: 32,
    height: 32,
    borderRadius: "10% 10% 10% 10",
    backgroundColor: "#3C37FF",
    transformOrigin: "bottom left",
  },
});

const dataValue = {
  heading: "Buy Ticket",
  subHeading: "",
};

type ticketValues = {
  price: number;
  ticketNumber: number;
  speed: number;
  deceleration: number;
  no_of_token: number;
  type: string;
  redeemCode: String;
  freeTicketAmt: number;
  couponId: string;
};

export default function BuyNow() {
  const navigate = useNavigate();
  const classes = useStyles({});
  const { user } = useAuth();
  const { id } = useParams();


  const [totalSoldTicket, settotalSoldTicket] = useState(0);
  const [jackpotSelected, setJackpotSelected] = useState(false);
  const [LotteryData, setLotteryData] = useState("");
  const [selectedBall, setSelectedBall] = useState(null);
  const [lotteryDetail, setLotteryDetail] = useState<any>();
  console.log(lotteryDetail, "lotteryDetail");
  const [searchParams] = useSearchParams();
  const redeemCode = searchParams.get("redeemCode");
  const freeTicketAmt = searchParams.get("freeTicketAmt");
  const couponId = searchParams.get("CouponId");
  console.log(couponId, "couponId");
  const initialValues: ticketValues = {
    price: 0,
    ticketNumber: 0,
    speed: 0,
    deceleration: 0,
    no_of_token: 0,
    type: "",
    redeemCode: "",
    freeTicketAmt: 0,
    couponId: couponId ? couponId : "",
  };


  useEffect(() => {
    getLotteryDetail();

    getData();
    availableTickets = (lotteryDetail?.numOfTicketOnSale || 0) - totalSoldTicket;
  }, []);


  const getLotteryDetail = async () => {
    let token = storage.getToken();
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    await axios
      .get(`${process.env.API_URL_PREFIX}/api/v1/user/lotteryDetailById/` + id, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Access-Control-Allow-Origin": "*",
          'TimeZone': timezone,

        },
      })
      .then((res) => {

        setLotteryDetail(res?.data)
      })

      .catch((err) => {
        console.log(err);
      });
  };
  let availableTickets =
    (lotteryDetail?.numOfTicketOnSale || 0) - totalSoldTicket;
  useEffect(() => {
    const getBallData = async () => {
      let token = storage.getToken();

      try {
        const res = await axios.get(
          `${process.env.API_URL_PREFIX}/api/v1/admin/buySpinBalls/${id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Access-Control-Allow-Origin": "*",
            },
          }
        );
        setSpinningBallData(res.data[0]);
      } catch (err) {
        console.log(err);
      }
    };

    getBallData();
  }, [id]);

  useEffect(() => {
    const getLotteryData = async () => {
      let token = storage.getToken();

      try {
        const res = await axios.get(
          `${process.env.API_URL_PREFIX}/api/v1/user/lotteryDetailById/${id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Access-Control-Allow-Origin": "*",
              TimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            },
          }
        );
        setLotteryData(res.data.jackpotSelected);
      } catch (err) {
        console.log(err);
      }
    };

    getLotteryData();
  }, [id]);

  const getData = async () => {
    let token = storage.getToken();
    // let formData
    // useLotteryTicketList({lotteryId:"649d4943c0a0d39915560799"})

    await axios
      .get(`${process.env.API_URL_PREFIX}/api/v1/user/ticketcount/` + id, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Access-Control-Allow-Origin": "*",
        },
      })
      .then((res) => {
        settotalSoldTicket(res.data[0].totalSoldLottery);
      })

      .catch((err) => {
        console.log(err);
      });
  };

  const [formValues, setFormValues] = useState<ticketValues>(initialValues);
  console.log(formValues, "formValues");
  const [count, setCount] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  console.log(totalAmount);

  const [jackpotAmount, setJackpotAmount] = useState(0);
  const [InputValue, setInputValue] = useState(3);
  const [SpeedValue, setSpeedValue] = useState(60);
  const [isLoading, setIsLoading] = useState(false);
  const [isRemovingOffer, setIsRemovingOffer] = useState<any>(false);
  console.log(isRemovingOffer, "isRemovingOffer");
  const countDownDate = new Date(lotteryDetail?.endDate || 0).getTime();
  const [countDown, setCountDown] = useState(
    new Date().getTime() - countDownDate
  );
  const [spinningBallData, setSpinningBallData] =
    useState<SpinningBallData | null>(null);
  const loadingMessages = [
    "⏳ We are processing your purchase, one moment please...",
    "🎟️ Your lucky tickets are being selected, hang tight!",
    "🔐 Securing your tickets on the blockchain...",
    "✅ Almost there! Finalizing your transaction...",
    "🍀 Hang tight! Confirming your lucky tickets...",
    "🧾 Just a few more seconds, preparing your entry...",
    "🔐 Locking in your tickets... almost done!",
    "🎫 Grabbing your golden ticket from the vault...",
    "🧠 Crunching the tickets... your luck is being calculated!",
    "✨ Summoning the blockchain magic... just a sec!",
    "🚀 Launching your transaction to the moon!",
    "🎰 Spinning the wheel of fortune... hang on!",
    "💫 Your lucky stars are aligning... please wait!",
    "📦 Wrapping your transaction gift... almost ready!",
    "⚙️ Spinning the gears of luck... stay with us!",
    "🧾 Your receipt from destiny is being printed...",
    "💸 Confirming your bet with the universe...",
    "🎯 Aiming for the jackpot... stay focused!",
    "📡 Connecting to the lottery gods... signal strong!",
    "🤖 Our crypto bots are working their magic...",
    "⏳ Time is ticking, your luck is cooking...",
  ];
  const [loadingMsg, setLoadingMsg] = useState(loadingMessages[0]);
  const sortedAvailableBalls =
    spinningBallData && spinningBallData.availableBalls
      ? [...spinningBallData.availableBalls]
        .filter((ball) => ball !== undefined)
        .sort((a, b) => a - b)
      : [];

  console.log(sortedAvailableBalls, "Sorted Available Balls");



  const ticketPrice: any = lotteryDetail?.ticketPrice || 0;
  console.log(ticketPrice, "ticketPrice");
  const updateAmounts = (tokenCount, isJackpotSelected, ticketPrice) => {
    console.log("calling...", tokenCount, isJackpotSelected)
    // Calculate base amount in USDC (always charged)
    const baseAmount: number = tokenCount * ticketPrice;
    
    let jackpotAmountInG2F = 0;
    if (!lotteryDetail?.LotteryTypeEvent) {
      // Regular jackpot calculation for non-free events
      const jackpotPricePerTicket = ticketPrice * 0.2; // 20% of ticket price in USDC
      const totalJackpotUSDC = tokenCount * jackpotPricePerTicket;
      
      // Convert USDC to G2F (assuming 1:1 ratio - adjust the rate as needed)
      const g2fConversionRate = 0.04; // Replace with actual G2F/USDC rate
      jackpotAmountInG2F = totalJackpotUSDC / g2fConversionRate;
    }
    
    console.log(baseAmount, "baseAmount");
    setJackpotAmount(isJackpotSelected ? jackpotAmountInG2F : 0);
    setTotalAmount(baseAmount);
  };

  useEffect(() => {
    updateAmounts(formValues.no_of_token, jackpotSelected, ticketPrice);
  }, [formValues.no_of_token, jackpotSelected, ticketPrice]);

  useEffect(() => {
    if (freeTicketAmt && Number(freeTicketAmt) > 0) {
      const initialTickets = Number(freeTicketAmt) * 2;
      setFormValues((prev) => ({
        ...prev,
        no_of_token: initialTickets,
        freeTicketAmt: Number(freeTicketAmt),
        redeemCode: redeemCode ? redeemCode : "",
      }));
      setCount(initialTickets);
      updateAmounts(initialTickets, jackpotSelected, ticketPrice);

      const minTicketsForOffer = freeTicketAmt ? Number(freeTicketAmt) * 2 : 0;
      const willRemoveOffer = formValues.no_of_token >= minTicketsForOffer;

      setIsRemovingOffer(willRemoveOffer);
    }
  }, [freeTicketAmt, redeemCode, ticketPrice]);

  const handleCount = (increment) => {
    const newTokenCount = formValues.no_of_token + increment;
    console.log(newTokenCount, "newTokenCount");

    if (newTokenCount <= availableTickets && newTokenCount >= 0) {
      const minTicketsForOffer = freeTicketAmt ? Number(freeTicketAmt) * 2 : 0;
      const willRemoveOffer = newTokenCount >= minTicketsForOffer;

      setIsRemovingOffer(willRemoveOffer);


      setCount((prevCount) => prevCount + increment);
      // setFormValues((prevValues) => ({
      //   ...prevValues,
      //   no_of_token: newTokenCount,
      //   ...(isRemovingOffer && {
      //     redeemCode: redeemCode ? redeemCode : "",
      //     freeTicketAmt: 0,
      //   }),
      // }));

      setFormValues((prevValues) => {
        if (willRemoveOffer) {

          return {
            ...prevValues,
            no_of_token: newTokenCount,
            redeemCode: redeemCode ? redeemCode : "",
            freeTicketAmt: freeTicketAmt ? Number(freeTicketAmt) : 0,
          };
        } else {
          return {
            ...prevValues,
            no_of_token: newTokenCount,
            redeemCode: "",
            freeTicketAmt: 0,
          };
        }
      });
      console.log(newTokenCount, isRemovingOffer, redeemCode, willRemoveOffer, minTicketsForOffer, "check");

      if (!willRemoveOffer && redeemCode) {
        Swal.fire({
          icon: "info",
          text: "Free Ticket Coupon removed because you reduced your ticket quantity.",
          color: "#fff",
          background: "black",
        });
      }
    } else {
      Swal.fire({
        icon: "error",
        title: "Oops",
        text: "You can select up to Available Ticket",
        color: "#fff",
        background: "black",
      });
    }
  };

  const handleAddOne = () => handleCount(1);

  const handleSubtractOne = () => handleCount(-1);

  const handleAddTen = () => handleCount(10);

  const handleSubtractTen = () => handleCount(-10);





  const handleFormSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setFormValues({
      ...formValues,
      speed: SpeedValue,
      deceleration: InputValue,
    });
    let data = {
      speed: SpeedValue,
      deceleration: InputValue,
      numOfToken: formValues.no_of_token,
      type: "crypto",
      redeemCode: formValues.redeemCode,
      freeTicketAmt: formValues.freeTicketAmt,
      jackpotStatus: jackpotSelected,
      selectedJackpotColourNumber: selectedBall || "",
      couponId: couponId ? couponId : "",
    };

    let idData: any = lotteryDetail?._id;
    handleLotteryDataValue(data, idData);
  };
  const generateLotteryAvailableTicket = () => {
    let num: any = lotteryDetail?.numOfTicketOnSale || 0;
    let num2 = lotteryDetail?.numOfTicketSold || 0;
    let num3 = num - num2;
    return num3;
  };
  const handleLotteryDataValue = async (data: any, idData: any) => {
    let msgIndex = 0;
    let interval: NodeJS.Timeout | null = null;

    try {
      setIsLoading(true);

      // Start rotating messages
      interval = setInterval(() => {
        msgIndex = (msgIndex + 1) % loadingMessages.length;
        setLoadingMsg(loadingMessages[msgIndex]);
      }, 2500);

      const res = await lotteryDataValue({
        data,
        idValue: idData,
        message: "Purchased Lottery Successfully",
      });

      clearInterval(interval);
      setIsLoading(false);

      await Swal.fire({
        background: "black",
        color: "#ffff",
        icon: "success",
        title: "Success!",
        text: res.message,
      });

      navigate("/app", { state: { refresh: true } });
    } catch (error: any) {
      setIsLoading(false);

      Swal.fire({
        icon: "error",
        background: "black",
        color: "#ffff",
         title: "Oops",
        text: `${error?.response?.data?.message || "Something went wrong"}`,
      });
    }
  };


  const handleBallClick = (number) => {
    setSelectedBall((prevSelectedBall) => {
      // Toggle selection based on the current state
      if (prevSelectedBall === number && jackpotSelected) {
        setJackpotSelected(false); // Deselect the checkbox when deselecting the ball
        return null; // Deselect the ball
      } else {
        setJackpotSelected(true); // Enable jackpot when selecting a ball
        return number; // Select the clicked ball
      }
    });
  };

  const handleCheckboxChange = (e) => {
    const isChecked = e.target.checked;
    setJackpotSelected(isChecked);
    updateAmounts(formValues.no_of_token, isChecked, null);
    if (!e.target.checked) {
      setSelectedBall(null); // Deselect ball when jackpot is unchecked
    }
  };

  const colors = [
    { light: yellow[700], dark: yellow[900] },
    { light: blue[700], dark: blue[900] },
    { light: red[700], dark: red[900] },
    { light: pink[900], dark: pink[800] },
    { light: orange[700], dark: orange[900] },
    { light: green[700], dark: green[900] },
    { light: purple[700], dark: purple[900] },
  ];

  const Ball = ({ number, color, colorDark, isSelected, onClick }) => {
    const ballStyles = useStyles({});

    return (
      <Box display="flex" flexDirection="column" alignItems="center" margin={1}>
        <Box
          className={`${ballStyles.ball} ${isSelected ? ballStyles.selectedBall : ""
            }`}
          style={{ backgroundColor: isSelected ? colorDark : color }}
          onClick={() => onClick(number)}
        >
          {number}
        </Box>
      </Box>
    );
  };

  const BallRow = ({ selectedBall, onBallClick, availableBalls }) => {
    return (
      <Box className={useStyles({}).ballRow}>
        {availableBalls &&
          availableBalls?.map((ballNumber, index) => (
            <Ball
              key={index}
              number={ballNumber}
              color={colors[ballNumber - 1]?.light}
              colorDark={colors[ballNumber - 1]?.dark}
              isSelected={selectedBall === ballNumber}
              onClick={onBallClick}
            />
          ))}
      </Box>
    );
  };


  return (
    <Box
      sx={{
        background: `linear-gradient(89.41deg, #1B1C2D 7.81%, rgba(27, 28, 45, 0) 38.09%), linear-gradient(1.53deg, #1B1C2D 13.32%, rgba(27, 28, 45, 0) 50.41%), linear-gradient(46.49deg, #1B1C2D 14.7%, rgba(27, 28, 45, 0) 43.39%), url(${HomeScreenImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundAttachment: "fixed",
        backgroundPosition: "center",
        padding: {
          xs: "10px 0",
          lg: "100px 0px 20px",
        },
        height: "100%",
      }}
    >
      <Box
        sx={{
          width: "100%",
          maxWidth: "768px",
          margin: "0 auto",
          textAlign: "center",
          fontFamily: '"Ubuntu", sans-serif',
          fontSize: "25px",
          lineHeight: "1.5",
        }}
      >
        <Typography
          component="h4"
          sx={{
            textTransform: "capitalize",
            fontWeight: "500 !important",
            marginBottom: { xs: "10px", md: "15px" },
            fontSize: { xs: "18px", md: "20px", lg: "24px" },
          }}
        >
          Buy Now
        </Typography>
      </Box>
      <Box
        sx={{
          maxWidth: "95%",
          margin: "0 auto",
        }}
      >
        <Box className={classes.myGridItem}>
          {isLoading && <LoadingModal message={loadingMsg} />}
          <Grid
            sx={{ width: "100%", mx: "auto" }}
            container
            spacing={{ xs: 2, md: 2, lg: 3 }}
            justifyContent="space-around"
          >
            <Grid item xs={12} sm={6}>
              <Box className={classes.innerGrid}>
                <Grid
                  container
                  className="Lotteries-buy-page"
                  style={{
                    margin: "auto",
                    flexFlow: "row wrap",
                    justifyContent: "space-between",
                    height: "100%",
                  }}
                >
                  <Grid item xs={5} sm={5} md={5} lg={5}>
                    <Box
                      sx={{
                        height: "100%",
                        width: "100%",
                        position: "relative",
                        background: "rgb(75 75 75 / 80%)",
                        borderRadius: "10px",
                      }}
                    >
                      <img
                        className={classes.innerGridFirst}
                        alt="lottery-name"
                        // eslint-disable-next-line no-template-curly-in-string
                        src={`${process.env.API_URL_PREFIX}/api/v1/admin/uploads/${lotteryDetail?.image}`}
                      />
                    </Box>
                  </Grid>
                  <Grid
                    item
                    xs={7}
                    sm={7}
                    md={7}
                    lg={7}
                    className={classes.innerGridSecond}
                  >
                    <Typography
                      component={"h2"}
                      align="center"
                      sx={{
                        textTransform: "uppercase",
                        color: "white",
                        fontSize: {
                          lg: "30px",
                          sm: "20px",
                          xs: "18px",
                        },
                      }}
                    >
                      {lotteryDetail?.lotteryName ? lotteryDetail?.lotteryName : ""}
                    </Typography>
                    <Typography
                      variant="caption"
                      align="center"
                      sx={{
                        color: "white",
                        fontSize: {
                          lg: "20px",
                          md: "18px",
                          xs: "16px",
                        },
                        display: "flex",
                        justifyContent: "center",
                        flexFlow: "row wrap",
                        gap: "5px",
                      }}
                    >
                      {" "}
                      Ticket Price :{" "}
                      <Typography
                        component={"span"}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          fontSize: {
                            lg: "20px",
                            md: "18px",
                            xs: "16px",
                          },
                        }}
                      >
                        <img
                          style={{
                            height: "auto",
                            width: "20px",
                            margin: "0 5px 0 0",
                          }}
                          src={whitet}
                          alt="currency"
                        />{" "}
                        {lotteryDetail?.ticketPrice
                          ? lotteryDetail?.ticketPrice
                          : " "}
                      </Typography>
                    </Typography>

                    <Typography
                      variant="h3"
                      align="center"
                      sx={{
                        color: "#FFBC00",
                        mt: "10px",
                        fontSize: {
                          xs: "12px",
                          sm: "14px",
                          md: "14px",
                          lg: "16px",
                        },
                        lineHeight: "1.5",
                      }}
                    >
                      DRAW DATE :{" "}
                      {moment(lotteryDetail?.lotteryDrawDate).format(
                        "DD-MM-YYYY"
                      )}
                      <br />
                      DRAW TIME : {`${lotteryDetail?.lotteryDrawTime} `}
                    </Typography>
                    {lotteryDetail?.endDate && lotteryDetail?.endTime ? (
                      <Typography
                        variant="h5"
                        align="center"
                        sx={{
                          fontSize: {
                            lg: "45px !important",
                            md: "35px !important",
                            xs: "25px !important",
                          },
                          fontWeight: "700",
                          wordBreak: "break-word",
                        }}
                      >
                        <Countdown
                          date={
                            new Date(
                              `${lotteryDetail?.endDate}T${lotteryDetail?.endTime}`
                            )
                          }
                        />
                      </Typography>
                    ) : (
                      // Skeleton loader as fallback UI
                      <Skeleton
                        variant="rectangular"
                        width="100%"
                        height={50} // Adjust height based on design
                        sx={{ borderRadius: "10px" }}
                      />
                    )}
                    <Typography
                      variant="h5"
                      align="center"
                      sx={{
                        color: "white",
                        fontSize: {
                          lg: "20px",
                          md: "18px",
                          xs: "16px",
                        },
                        display: "flex",
                        justifyContent: "center",
                        flexFlow: "row wrap",
                        gap: "5px",
                        mt: "5px",
                      }}
                    >
                      Total tickets :
                      <CurrencyFormat
                        value={lotteryDetail?.numOfTicketOnSale}
                        thousandSeparator={","}
                        displayType={"text"}
                        decimalSeparator={"."}
                      />
                    </Typography>
                  </Grid>
                </Grid>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Box
                className={classes.innerGrid}
                style={{ height: "100%", boxSizing: "border-box" }}
              >
                <TableContainer
                  component={Paper}
                  className={classes.tableContainer}
                  sx={{
                    maxHeight: { xs: "360px", sm: "380px", md: "400px" },
                    minHeight: "100%",
                    overflowX: "hidden",
                    borderRadius: "8px",
                    backgroundColor: "rgba(5, 5, 24, 0.95)",
                    boxShadow: "none",
                  }}
                >
                  <Table
                    className={classes.table}
                    aria-label="custom table"
                    sx={{
                      p: { xs: "10px", sm: "25px" },
                      minWidth: {
                        xs: "240px !important",
                        lg: "270px !important",
                      },
                    }}
                  >
                    <TableHead sx={{ backgroundColor: "#0D0D36 !important" }}>
                      <TableRow>
                        <TableCell 
                          className={classes.tableHeader}
                          sx={{
                            width: { xs: "20%", sm: "25%", md: "30%" },
                            padding: { xs: "12px 8px", sm: "16px 12px", md: "16px" },
                          }}
                        >
                          <Box
                            component="img"
                            src={Logo}
                            alt="table logo"
                            className={classes.logoTable}
                            sx={{
                              width: { xs: "35px", sm: "40px", md: "45px" },
                              height: "auto",
                              objectFit: "contain"
                            }}
                          />
                        </TableCell>
                        <TableCell 
                          className={classes.tableHeader}
                          sx={{
                            width: { xs: "40%", sm: "35%", md: "40%" },
                            padding: { xs: "12px 8px", sm: "16px 12px", md: "16px" },
                          }}
                        >
                          <Typography
                            variant="subtitle2"
                            sx={{
                              color: "#FFFFFF",
                              fontSize: { xs: "13px", sm: "14px", md: "16px" },
                              fontWeight: 500,
                              textAlign: { xs: "start", md: "center" },
                              whiteSpace: "nowrap"
                            }}
                          >
                            Total Prize-pool 
                          </Typography>
                        </TableCell>
                        <TableCell 
                          className={classes.tableHeader}
                          sx={{
                            width: { xs: "40%", sm: "40%", md: "30%" },
                            padding: { xs: "12px 8px", sm: "16px 12px", md: "16px" },
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "flex-end",
                              gap: { xs: "4px", sm: "6px" }
                            }}
                          >
                            <Box
                              component="img"
                              alt="white dollar"
                              src={whitet}
                              sx={{
                                height: "auto",
                                width: { xs: "20px", sm: "25px", md: "31px" },
                                objectFit: "contain"
                              }}
                            />
                            <Typography
                              sx={{
                                color: "#FFFFFF",
                                fontSize: { xs: "13px", sm: "14px", md: "16px" },
                                fontWeight: 500,
                                whiteSpace: "nowrap"
                              }}
                            >
                              <CurrencyFormat
                                value={lotteryDetail?.drawPrize.reduce(
                                  (acc, curr) => acc + parseInt(curr),
                                  0
                                )}
                                thousandSeparator={","}
                                displayType={"text"}
                                decimalSeparator={"."}
                              />
                            </Typography>
                          </Box>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                  </Table>
                  <Box
                    className="dashboardSpanList"
                    sx={{
                      maxHeight: { xs: "260px", sm: "280px", md: "300px" },
                      minHeight: "100%",
                      height: "auto",
                      overflowY: "auto",
                      overflowX: "hidden",
                      minWidth: { xs: "240px", lg: "270px" },
                      "&::-webkit-scrollbar": {
                        width: "8px",
                        backgroundColor: "rgba(255, 255, 255, 0.1)",
                        borderRadius: "4px",
                      },
                      "&::-webkit-scrollbar-thumb": {
                        backgroundColor: "rgba(255, 255, 255, 0.2)",
                        borderRadius: "4px",
                        "&:hover": {
                          backgroundColor: "rgba(255, 255, 255, 0.3)",
                        }
                      }
                    }}
                  >
                    <Table
                      className={classes.table}
                      aria-label="custom table"
                      sx={{
                        p: { xs: "10px", sm: "25px" },
                        minWidth: {
                          xs: "240px !important",
                          lg: "270px !important",
                        },
                      }}
                    >
                      <TableBody>
                        {lotteryDetail?.drawPrize?.map((row, index) => (
                          <TableRow key={index + 1}>
                            <TableCell
                              className={classes.tableData}
                              sx={{
                                width: { xs: "20%", sm: "25%", md: "30%" },
                                padding: { xs: "12px 8px", sm: "16px 12px", md: "16px" },
                                borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
                              }}
                            >
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: { xs: "4px", sm: "6px", md: "8px" }
                                }}
                              >
                                <span className="dotIcon"></span>
                                <Typography
                                  sx={{
                                    fontSize: { xs: "12px", sm: "13px", md: "14px" },
                                    fontWeight: 500,
                                    color: "white",
                                    opacity: 0.8,
                                    whiteSpace: "nowrap"
                                  }}
                                >
                                  {getOrdinalSuffix(index + 1) + " " + "Spin"}
                                </Typography>
                              </Box>
                            </TableCell>
                            <TableCell
                              className={classes.tableData}
                              sx={{
                                width: { xs: "40%", sm: "35%", md: "40%" },
                                padding: { xs: "12px 8px", sm: "16px 12px", md: "16px" },
                                borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
                              }}
                            >
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "flex-end",
                                  gap: { xs: "4px", sm: "6px" }
                                }}
                              >
                                <Box
                                  component="img"
                                  alt="yellow dollar"
                                  src={yellowt}
                                  sx={{
                                    height: "auto",
                                    width: { xs: "14px", sm: "16px", md: "17px" },
                                    objectFit: "contain"
                                  }}
                                />
                                <Typography
                                  sx={{
                                    fontSize: { xs: "12px", sm: "13px", md: "14px" },
                                    fontWeight: 500,
                                    color: "white",
                                    opacity: 0.8,
                                    whiteSpace: "nowrap"
                                  }}
                                >
                                  <CurrencyFormat
                                    value={lotteryDetail?.drawPrize[index]}
                                    thousandSeparator={","}
                                    displayType={"text"}
                                    decimalSeparator={"."}
                                  />
                                </Typography>
                              </Box>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </Box>
                </TableContainer>
              </Box>
            </Grid>
          </Grid>

          <Box sx={{ mt: "20px" }}>
            <Grid container direction="row" spacing={{ xs: 2, md: 4 }}>
              <Grid item xs={12} md={4}>
                <Paper
                  className={clsx(classes.first, classes.paperClass)}
                  sx={{
                    p: {
                      xs: "20px 18px !important",
                      md: "40px 36px !important",
                    },
                    //height: "500px !important", // Ensuring paper adjusts its height based on content
                    //overflow: "hidden", // Prevent content from overflowing
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                  }}
                >
                  <Grid container>
                    <Grid item xs={12}>
                      <Grid
                        container
                        className={classes.availableTickets}
                        sx={{ p: { xs: "12px", md: "20px" } }}
                        alignItems="center"
                      >
                        <Grid item xs={6} sm={6} lg={6}>
                          <Typography
                            variant="subtitle2"
                            textAlign="left"
                            sx={{ fontWeight: "700", lineHeight: 1 }}
                          >
                            Price :
                          </Typography>
                        </Grid>
                        <Grid item xs={6} sm={6} lg={6}>
                          <Typography
                            variant="h4"
                            sx={{ fontWeight: "700", lineHeight: 1 }}
                            textAlign="right"
                          >
                            {lotteryDetail?.ticketPrice}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>

                  <Box className={classes.noOfTickets}>
                    <Typography
                      variant="h5"
                      textAlign="center"
                      sx={{ marginTop: "20px" }}
                    >
                      Select No. of Tickets:
                    </Typography>
                    <Stack
                      flexDirection="column"
                      alignItems="center"
                      sx={{ mt: "13px" }}
                    >
                      <ButtonGroup sx={{ mb: "11px" }}>
                        <Button
                          className={classes.substract}
                          onClick={handleSubtractOne}
                        >
                          <RemoveIcon sx={{ fontSize: "15px" }} />
                        </Button>
                        <Button
                          className={classes.minimumTicket}
                          sx={{
                            borderRadius: "10px !important",
                            color: "#ffff",
                            mx: "12px !important",
                          }}
                        >
                          {" "}
                          <span style={{ color: "#ffff !important" }}>
                            {formValues.no_of_token || 1}
                          </span>
                        </Button>
                        <Button
                          className={classes.substract}
                          onClick={handleAddOne}
                        >
                          <AddIcon sx={{ fontSize: "15px" }} />
                        </Button>
                      </ButtonGroup>
                      <ButtonGroup>
                        <Button
                          className={classes.substract}
                          onClick={handleSubtractTen}
                        >
                          <RemoveIcon sx={{ fontSize: "15px" }} />
                        </Button>
                        <Button
                          sx={{
                            borderRadius: "10px !important",
                            mx: "12px !important",
                            background: "#ffff !important",
                          }}
                          disabled
                        >
                          <span style={{ color: "#ffff !important" }}>
                            {formValues.no_of_token || 10}
                          </span>
                        </Button>
                        <Button
                          className={classes.substract}
                          onClick={handleAddTen}
                        >
                          <AddIcon sx={{ fontSize: "15px" }} />
                        </Button>
                      </ButtonGroup>
                    </Stack>
                  </Box>

                  {LotteryData && (
                    <Grid container alignItems="center" spacing={3}>
                      {/* Checkbox Grid Item */}
                      <Grid item xs={12} sm={6}>
                        <FormControlLabel
                          className={classes.checkboxLabel}
                          control={
                            <Checkbox
                              sx={{
                                color: "#ffffff",
                              }}
                              checked={jackpotSelected}
                              onChange={handleCheckboxChange}
                              id="jackpotSelected"
                            />
                          }
                          label="Enable Jackpot"
                        />
                      </Grid>

                      {/* Balls Grid Item */}
                      <Grid item xs={12} sm={6}>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                            marginTop: "15px",
                            marginBottom: "25px",
                            "& div ": {
                              gap: "10px",
                              flexFlow: "row wrap",
                            },
                            "& div div": {
                              "&:hover": {
                                cursor: "pointer",
                              },
                            },
                          }}
                        >
                          <BallRow
                            selectedBall={selectedBall}
                            onBallClick={handleBallClick}
                            availableBalls={sortedAvailableBalls}
                          />
                        </Box>
                      </Grid>
                    </Grid>
                  )}

                  <Grid container>
                    <Grid item xs={12}>
                      <Grid
                        container
                        className={classes.availableTickets}
                        sx={{
                          p: { xs: "10px", md: "20px" },
                          maxHeight: "70px",
                          display: "flex",
                          marginBottom: "20px",
                        }}
                      >
                        <Grid
                          item
                          xs={8}
                          md={8}
                          sx={{
                            maxHeight: "20px",
                            marginTop: "auto",
                            marginBottom: "auto",
                          }}
                        >
                          {" "}
                          <Typography
                            variant="subtitle2"
                            textAlign="left"
                            sx={{ lineHeight: "normal" }}
                          >
                            Total Tickets{" "}
                          </Typography>
                        </Grid>

                        <Grid
                          item
                          xs={4}
                          md={4}
                          sx={{
                            maxHeight: "20px",
                            display: "flex",
                            margin: "auto",
                          }}
                        >
                          <Typography
                            variant="h4"
                            sx={{
                              fontWeight: "700",
                              margin: "auto",
                              lineHeight: "0.1",
                            }}
                            textAlign="right"
                          >
                            {formValues.no_of_token}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Paper>
              </Grid>

              <Grid item xs={12} md={8}>
                <Grid container spacing={{ xs: 2, md: 4 }}>
                  <Grid item xs={12} md={6}>
                    <Paper className={classes.paperClass} sx={{ p: "20px" }}>
                      <Stack
                        spacing={2}
                        direction="column"
                        sx={{ mb: 1 }}
                        alignItems="flex-start"
                      >
                        <Typography
                          variant="h6"
                          component="h6"
                          // textAlign="left"
                          sx={{
                            opacity: "0.8",
                            textAlign: { xs: "left", md: "left" },
                          }}
                        >
                          Set your wheel settings
                        </Typography>
                        <Box
                          sx={{
                            padding: { xs: "10px", sm: "20px" },
                            width: "100%",
                            display: "block",
                          }}
                        >
                          <Grid container spacing={2} alignItems="center">
                            <Grid item xs={12} md={6}>
                              <Typography
                                variant="subtitle2"
                                // textAlign="left"
                                sx={{
                                  textAlign: { xs: "left", md: "left" },
                                }}
                              >
                                Speed
                              </Typography>
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <PrettoSlider
                                valueLabelDisplay="auto"
                                aria-label="speed"
                                name="speed"
                                defaultValue={60}
                                value={SpeedValue}
                                onChange={(_, value: any) =>
                                  setSpeedValue(value)
                                }
                                min={60}
                                max={120}
                              />
                            </Grid>
                          </Grid>
                          <Grid
                            container
                            sx={{
                              mt: {
                                xs: "6px !important",
                                md: "10px !important",
                              },
                            }}
                            spacing={2}
                            alignItems="center"
                          >
                            <Grid item xs={12} md={6}>
                              <Typography
                                variant="subtitle2"
                                sx={{
                                  textAlign: { xs: "left", md: "left" },
                                }}
                              >
                                Decelaration
                              </Typography>
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <PrettoSlider
                                valueLabelDisplay="auto"
                                aria-label="deceleration"
                                defaultValue={3}
                                name="deceleration"
                                value={InputValue}
                                min={3}
                                onChange={(_, value: any) =>
                                  setInputValue(value)
                                }
                                max={7}
                              />
                            </Grid>
                          </Grid>
                        </Box>
                      </Stack>
                    </Paper>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Paper className={classes.paperClass}>
                      <img src={trophy} alt="trophy"></img>
                      <Typography variant="h5" textAlign="center">
                        Win Chance{" "}
                      </Typography>
                      <br />
                      <Typography
                        textAlign="center"
                        sx={{
                          fontSize: { xs: "30px", md: "40px !important" },
                          fontWeight: "bold",
                        }}
                      >
                        1 :{" "}
                        {lotteryDetail?.numOfTicketOnSale &&
                          formValues.no_of_token > 0
                          ? Math.round(
                            lotteryDetail?.numOfTicketOnSale /
                            (formValues.no_of_token + totalSoldTicket)
                          )
                          : lotteryDetail?.numOfTicketOnSale}
                      </Typography>
                      <Typography
                        variant="h5"
                        sx={{
                          lineHeight: 0.334,
                          justifyContent: "center",
                          display: { md: "flex", xs: "block" },
                          alignItems: "center",
                          gap: "10px",
                        }}
                        textAlign="center"
                      >
                        <p
                          className=" m-auto"
                          style={{ display: "block", lineHeight: 1.5 }}
                        >
                          Previous Bought tickets :
                        </p>
                        <p>
                          {/* {totalSoldTicket} */}
                          <CurrencyFormat
                            value={totalSoldTicket}
                            thousandSeparator={","}
                            displayType={"text"}
                            decimalSeparator={"."}
                          />
                        </p>
                      </Typography>
                    </Paper>
                  </Grid>
                  <Grid item xs={12} md={12}>
                    <Paper
                      className={classes.paperClass}
                      sx={{
                        minHeight: { xs: 69, md: 210 },
                        height: "100%",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <Grid
                        container
                        spacing={3}
                        alignItems="center"
                        justifyContent="center"
                        sx={{ flexFlow: "row wrap" }}
                      >
                        <Grid item xs={12} sm={8}>
                          <Grid
                            container
                            spacing={2}
                            className={classes.ticketPrize}
                          >
                            <Grid item xs={8} md={8}>
                              {" "}
                              <Typography variant="subtitle2" textAlign="left">
                                Ticket Price{" "}
                                <Box
                                  sx={{
                                    fontSize: { md: "20px", xs: "10px" },
                                    fontWeight: "700",
                                  }}
                                >
                                  {" "}
                                  ({formValues.no_of_token} Tickets *{" "}
                                  {lotteryDetail?.ticketPrice})
                                </Box>{" "}
                              </Typography>
                            </Grid>

                            <Grid item xs={4} md={4}>
                              <Typography
                                variant="h4"
                                sx={{ fontWeight: "700" }}
                                textAlign="right"
                              >
                                {totalAmount} USDC

                              </Typography>
                            </Grid>

                            {jackpotSelected && (
                              <>
                                <Grid
                                  item
                                  xs={8}
                                  md={8}
                                  sx={{ marginTop: "20px" }}
                                >
                                  <Typography
                                    variant="subtitle2"
                                    textAlign="left"
                                  >
                                    Jackpot Price
                                    <Box
                                      sx={{
                                        fontSize: {
                                          md: "20px",
                                          xs: "10px",
                                        },
                                        fontWeight: "700",
                                      }}
                                    >
                                      {lotteryDetail?.LotteryTypeEvent ? (
                                        `(${formValues.no_of_token} Tickets * FREE)`
                                      ) : (
                                        `(${formValues.no_of_token} Tickets * ${((lotteryDetail?.ticketPrice * 0.2)).toFixed(1)} USDC)`
                                      )}
                                    </Box>
                                  </Typography>
                                </Grid>

                                <Grid item xs={4} md={4}>
                                  <Typography
                                    variant="h4"
                                    sx={{
                                      fontWeight: "700",
                                      marginTop: "20px",
                                      whiteSpace: "nowrap",
                                    }}
                                    textAlign="right"
                                  >
                                    {lotteryDetail?.LotteryTypeEvent ? "FREE" : `${Number(jackpotAmount).toFixed(1)} G2F`}
                                  </Typography>
                                </Grid>
                              </>
                            )}
                            {redeemCode && freeTicketAmt && isRemovingOffer && (
                              <>
                                <Grid
                                  item
                                  xs={8}
                                  md={8}
                                  sx={{ marginTop: "20px" }}
                                >
                                  <Typography
                                    variant="subtitle2"
                                    textAlign="left"
                                  >
                                    Coupon Prize Free Tickets
                                  </Typography>
                                </Grid>

                                <Grid item xs={4} md={4}>
                                  <Typography
                                    variant="h4"
                                    sx={{
                                      fontWeight: "700",
                                      marginTop: "20px",
                                      whiteSpace: "nowrap",
                                    }}
                                    textAlign="right"
                                  >
                                    -{Number(freeTicketAmt)} USDC
                                  </Typography>
                                </Grid>

                                <Grid item md={6} xs={6}>
                                  <Typography
                                    sx={{
                                      fontSize: "14px",
                                      backgroundColor: "#3C37FF",
                                      borderRadius: "5px",
                                      padding: "5px",
                                    }}
                                  >
                                    Free Ticket Coupon
                                  </Typography>
                                </Grid>
                                <Grid item md={6} xs={6}>
                                  <TextField
                                    sx={{
                                      width: "100%",
                                      fontSize: "14px",
                                      fontWeight: "700",
                                      textAlign: "center",
                                      "& .MuiInputBase-input": {
                                        padding: "6px 10px !important",
                                      },
                                    }}
                                    placeholder="Coupon Code"
                                    name="redeemCode"
                                    value={formValues?.redeemCode}
                                  />
                                </Grid>

                                <Grid
                                  item
                                  xs={8}
                                  md={8}
                                  sx={{ marginTop: "20px" }}
                                >
                                  <Typography
                                    variant="subtitle2"
                                    textAlign="left"
                                  >
                                    Total Ticket Price
                                  </Typography>
                                </Grid>

                                <Grid item xs={4} md={4}>
                                  <Typography
                                    variant="h4"
                                    sx={{
                                      fontWeight: "700",
                                      marginTop: "20px",
                                      whiteSpace: "nowrap",
                                    }}
                                    textAlign="right"
                                  >
                                    {`${totalAmount - Number(freeTicketAmt)} USDC`}
                                    {Number(jackpotAmount) !== 0 && ` + ${Number(jackpotAmount).toFixed(1)} G2F`}
                                  </Typography>
                                </Grid>
                              </>
                            )}
                          </Grid>
                        </Grid>

                        <Grid item xs={12} sm={"auto"}>
                          {isLoading ? (
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <CircularProgress size={40} />
                            </Box>
                          ) : (
                            <Button
                              variant="contained"
                              sx={{
                                p: { md: "14px 28px", xs: "10px 10px" },
                              }}
                              type="submit"
                              disabled={isLoading}
                              onClick={handleFormSubmit}
                              className="gradientButton"
                            >
                              Buy Tickets
                            </Button>
                          )}
                        </Grid>
                      </Grid>
                    </Paper>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Box>

          <Box sx={{ mt: { xs: "15px", md: "25px" } }}>
            <Notes />
          </Box>
          <StaticFAQ />
        </Box>
      </Box>
    </Box>
  );
}
